import React, { useContext, useEffect, useState } from 'react'
import { Formik, Form } from 'formik'
import { FiEye, FiSearch, FiX } from 'react-icons/fi'
import { useHistory } from 'react-router-dom'

import { Container } from './styles'
import { Button, Select, Textbox } from '../../../../components/Form'
import Card from '../../../../components/Card'
import { api, authHeaders } from '../../../../services/api'
import masks from '../../../../util/masks'
import ibge from '../../../../services/ibge'
import formUtils from '../../../../util/form'
import Table from '../../../../components/Table'
import { concatFormacoes } from '../../EspacoMedico/DadosCadastrais'

import fileIcon from '../../../../assets/images/file-icon.png'
import { GlobalContext } from '../../../../contexts/GlobalContext'
import { TipContext } from '../../../../contexts/TipContext'
import { loadTips } from '../../../../util/tip'

const initialValues = {
	nome: '',
	cpf: '',
	uf: null,
	cidade: null,
	faculdade: null,
	grau: null
}

export default function () {
	const history = useHistory()

	const { checkException } = useContext(GlobalContext)
	const { setCodigo, tips } = useContext(TipContext)

	const [faculdades, setFaculdades] = useState([])
	const [graus, setGraus] = useState([])
	const [UFs, setUFs] = useState([])
	const [cidades, setCidades] = useState([])
	const [formacoes, setFormacoes] = useState([])
	const [formacoesSelecionadas, setFormacoesSelecionadas] = useState([])
	const [resultadoBusca, setResultadoBusca] = useState(null)

	async function loadUFs() {
		const { data } = await ibge.get('estados')

		setUFs(data.map(({ sigla }) => sigla).sort())
	}

	async function loadCidades(uf) {
		const { data } = await ibge.get(`estados/${uf}/municipios`)

		setCidades(data.map(({ nome }) => nome).sort())
	}

	async function loadGraus() {
		try {
			const response = await api.get('grau_formacao')

			setGraus(response)
		} catch (e) {
			checkException(e)
		}
	}

	async function loadFaculdades() {
		try {
			const faculdades = await api.get('faculdade')

			setFaculdades(faculdades)
		} catch (e) {
			checkException(e)
		}
	}

	async function loadFormacoes(id) {
		try {
			const data = await api.get('formacao', {
				params: {
					pai_id: id
				}
			})

			setFormacoes(data)
		} catch (e) {
			checkException(e)
		}
	}

	async function handleSearch(values) {
		try {
			values = formUtils.extractFormValues(values)

			const data = await api.post('talento', {
				nome: values.nome,
				cpf: values.cpf,
				uf: values.uf,
				cidade: values.cidade,
				instituicao: values.faculdade,
				grau: values.grau,
				formacao: formacoesSelecionadas.at(-1)?.value
			}, authHeaders())

			setResultadoBusca(data.map(item => ({
				id: item.id,
				nome: item.nome,
				cpf: item.documentos.find(doc => doc.tipo_documento.id === 2)?.identificador,
				formacoes: `
					<div class="flex flex-col gap-2 py-1">
						${item.formacoes.reduce((result, current) => {
					let linkCertificado

					if (current.certificado?.link) {
						linkCertificado = `
									<a href="${current.certificado.link}" target="_blank">
										<img src="${fileIcon}" class="w-4" />
									</a>
								`
					}

					return [
						...result,
						`<div class="flex items-center gap-2">
									${linkCertificado || ''}

									${current.grau.descricao} em ${concatFormacoes(current.formacao)}
								</div>`
					]
				}, []).join('')}
					</div>
				`
			})))
		} catch (e) {
			console.log(e)

			checkException(e)
		}
	}

	function handleRemoveFormacao(id) {
		const posicao = formacoesSelecionadas.findIndex(i => i.value === id)
		const updated = formacoesSelecionadas.slice(0, posicao)

		const ultimo = updated.at(-1)

		setFormacoesSelecionadas(updated)

		loadFormacoes(ultimo?.value || undefined)
	}

	function handleAbrirPerfil({ id }) {
		history.push(`perfil/${id}`)
	}

	useEffect(() => {
		loadTips(setCodigo, 'form_pesquisa_talento')

		loadGraus()
		loadFaculdades()
		loadUFs()
		loadFormacoes()
	}, [])

	useEffect(() => {
		if (formacoesSelecionadas.length) {
			const ultimo = formacoesSelecionadas.at(-1)

			loadFormacoes(ultimo.value)
		}
	}, [formacoesSelecionadas])

	return (
		<Container>
			<Card>
				<h1>Busca de talentos</h1>

				<Formik
					onSubmit={handleSearch}
					initialValues={initialValues}
				>
					{({ setFieldValue, isSubmitting }) => (
						<Form className="flex flex-col md:grid md:grid-cols-3 ">
							<Textbox
								name="nome"
								label="Nome"
							/>

							<Textbox
								name="cpf"
								label="CPF"
								mask={masks.cpf}
							/>

							<Select
								name="grau"
								label="Grau"
								options={graus.map(grau => ({
									label: grau.descricao,
									value: grau.id
								}))}
								onChange={(selected, meta) => { setFieldValue(meta.name, selected) }}
							/>

							<Select
								name="faculdade"
								label="Instituição de ensino"
								options={faculdades.map(faculdade => ({
									label: `${faculdade.descricao} ${faculdade.sigla ? `(${faculdade.sigla})` : ''}`,
									value: faculdade.id
								}))}
								onChange={(selected, meta) => { setFieldValue(meta.name, selected) }}
							/>

							<Select
								name="uf"
								label="UF"
								options={UFs.map(uf => ({
									label: uf,
									value: uf
								}))}
								onChange={(selected, meta) => {
									setFieldValue(meta.name, selected)

									loadCidades(selected.value)

									setFieldValue('cidade', null)
								}}
							/>

							<Select
								name="cidade"
								label="Cidade"
								onChange={(selected, actionMeta) => setFieldValue(actionMeta.name, selected)}
								options={cidades.map(cidade => ({
									label: cidade,
									value: cidade
								}))}
							/>

							<Select
								name="formacao"
								label="Formação"
								options={formacoes.map(formacao => ({
									label: formacao.descricao,
									value: formacao.id
								}))}
								onChange={(selected, meta) => {
									setFormacoesSelecionadas(old => [...old, selected])

									setFieldValue(meta.name, null)
								}}
							/>

							{formacoesSelecionadas && (
								<div className="flex items-center gap-2 h-11 self-end my-1 px-2 col-span-2">
									{formacoesSelecionadas.map(i => (
										<div key={i.value} className="bg-white p-2 rounded-lg text-slate-800 flex gap-2 items-center">
											{i.label}

											<FiX
												size={18}
												className="cursor-pointer hover:opacity-80"
												onClick={() => { handleRemoveFormacao(i.value) }}
											/>
										</div>
									))}
								</div>
							)}

							<Button type="submit" className="white self-end col-span-3 w-fit justify-self-end" loading={isSubmitting}>
								Buscar
								<FiSearch size={18} />
							</Button>
						</Form>
					)}
				</Formik>

				{!!resultadoBusca && (
					<div>
						<Table
							headers={[
								{ name: 'nome', value: 'Nome' },
								{ name: 'cpf', value: 'CPF', centered: true },
								{ name: 'formacoes', value: 'Formações' }
							]}
							data={resultadoBusca}
							actions={[
								{
									action: handleAbrirPerfil,
									icon: FiEye,
									iconSize: 16,
									name: 'Mostrar perfil'
								}
							]}
						/>
					</div>
				)}
			</Card>
		</Container>
	)
}
